import { TrackingService } from 'sharebase/services/trackingService';

require('./showExperimentVariation.styles');

export function ShowExperimentVariationDirective(
    sbTrackingService:TrackingService
): ng.IDirective {
    return {
        restrict: 'A',
        link: ($scope, element, attrs) => {  
            if(!angular.isDefined(attrs.sbShowForExperimentKey)){
                throw new Error('Must supply an experiment to show.');
            }
            if(!angular.isDefined(attrs.sbShowForVariation)){
                throw new Error('Must supply a variation to show.');
            }

            //default state is hidden
            element.attr('variation-hidden', 'true');

            let variation = sbTrackingService.getExperimentVariant(attrs.sbShowForExperimentKey);
            if(variation === parseInt(attrs.sbShowForVariation)){
                element.removeAttr('variation-hidden');
            }
        }
    };
}
ShowExperimentVariationDirective.$inject = [
    'sbTrackingService'
];


// WEBPACK FOOTER //
// ./src/sharebase/components/showExperimentVariation/showExperimentVariation.ts